import React from "react";
import { PlayerListElement, Image } from "../../../../client/api";
import TopScorerPanel from "./TopScorerPanel";
import MatchDayPanel from "./MatchDayPanel";
import PreviewPanel from "./PreviewPanel";
import BetPanel from "./BetPanel";

type TopScorerProps = {
  player1?: PlayerListElement | null;
  player2?: PlayerListElement | null;
  emblem1?: Image;
  emblem2?: Image;
  goals1?: number;
  goals2?: number;
};

type MatchDayProps = {
  title: string;
  leagueId: number;
  matchDayOverride?: number;
};

type PreviewProps = {
  previewLeagueName?: string;
  previewLeagueId?: number;
  previewStartTime?: number;
};

type BetProps = {
  betMatchId?: number;
  betTeam1Name?: string;
  betTeam2Name?: string;
  betIsFutureMatch?: boolean;
  betTeam1Emblem?: Image;
  betTeam2Emblem?: Image;
};

const RightPanel: React.FC<
  Partial<TopScorerProps> & { matchDay?: MatchDayProps } & PreviewProps & BetProps
> = ({
  player1,
  player2,
  emblem1,
  emblem2,
  goals1,
  goals2,
  matchDay,
  previewLeagueName,
  previewLeagueId,
  previewStartTime,
  betMatchId,
  betTeam1Name,
  betTeam2Name,
  betIsFutureMatch,
  betTeam1Emblem,
  betTeam2Emblem,
}) => (
  <div className="flex flex-col gap-4">
    {(player1 || player2 || emblem1 || emblem2) && (
      <TopScorerPanel player1={player1} player2={player2} emblem1={emblem1} emblem2={emblem2} goals1={goals1} goals2={goals2} />
    )}
    {previewLeagueName && previewLeagueId != null && previewStartTime != null && (
      <PreviewPanel leagueName={previewLeagueName} leagueId={previewLeagueId} startTime={previewStartTime} />
    )}
    {betMatchId != null && betTeam1Name && betTeam2Name && (
      <BetPanel
        matchId={betMatchId}
        team1Name={betTeam1Name}
        team2Name={betTeam2Name}
        team1Emblem={betTeam1Emblem}
        team2Emblem={betTeam2Emblem}
        isFutureMatch={!!betIsFutureMatch}
      />
    )}
    {matchDay && (
      <MatchDayPanel title={matchDay.title} leagueId={matchDay.leagueId} matchDayOverride={matchDay.matchDayOverride} />
    )}
  </div>
);

export default RightPanel;


